var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpcomingEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 114
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-upcoming-empty_svg__a",
    x1: "95.577%",
    x2: "3.352%",
    y1: "4.423%",
    y2: "96.648%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#AFB3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CFCFCF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M0 98h15.211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-upcoming-empty_svg__a)",
    stroke: "#202E4A",
    strokeWidth: 3,
    d: "M45.681 32H83.32A7.681 7.681 0 0191 39.681V90.32A7.681 7.681 0 0183.319 98H45.68A7.681 7.681 0 0138 90.319V39.68A7.681 7.681 0 0145.681 32z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeWidth: 3,
    d: "M56.954 0h15.387a2.954 2.954 0 012.955 2.954v28.864H54V2.954A2.954 2.954 0 0156.954 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M54 12.544V4.048C54 2.918 54.917 2 56.048 2h17.2c1.13 0 2.048.917 2.048 2.048v8.558"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.004,
    cy: 5.78,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 3.258,
    ry: 3.264
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.65,
    cy: 79.648,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 4.397,
    ry: 4.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.172,
    cy: 59.759,
    fill: "#202E4A",
    rx: 2.693,
    ry: 2.699
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.53,
    cy: 22.329,
    fill: "#202E4A",
    rx: 1.629,
    ry: 1.632
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M23 98h44.112M76 98h23.582"
  }))));
}
export default SvgIcUpcomingEmpty;